import styled from 'styled-components';

const Footer = styled.footer`
  font-size: 16px;
`;

export const DarkFooter = styled(Footer)`
  background-color: black;
  color: #acb2b6;
`;

export const MaerskFooter = styled(Footer)`
  background-color: #00243d;
  color: #b2b8bb;
`;
